import React, { Component } from 'react';

import { connect } from 'react-redux';
import { PathName } from '../../constant';

import SupplierStatCard from '../../componets/SupplierStatCard.jsx';
import * as StatiticActions from '../../actions/Actions_StatiticManager.js';

import '../../App.css';

let _AgentList;

class AgentStatPanel extends Component {

    state = {}

    constructor(props) {
        super(props);

        const _filter = { startDate: '2018-01-01' };
        this.props.getAPIBestAgentList();
    }

    componentWillReceiveProps(nextProps) {

        const { StatiticManager } = nextProps;

        if (!!StatiticManager) {

            const { actions, data } = StatiticManager.STATITIC_REDUCER;

            switch (actions) {
                case StatiticActions.GET_BEST_AGENT_STAT_SUCCESS:
                    {
                        _AgentList = data.results.data;
                        //console.log(`${actions} : `, _AgentList)
                    } break;

                case StatiticActions.GET_BEST_AGENT_STAT_FAILURE:
                    {

                    } break;
            }
        }
    }

    render() {

        const { AgentList, isLoading } = this.props;
        // console.log('AgentStatPanel : ', AgentList)

        return (
            <div className="App-content">
                <div style={{ flex: 4, marginRight: '10px' }}>
                    <SupplierStatCard
                        Info={_AgentList || AgentList}
                        Topics={`Top Agent Booking`}
                        Disable={false}
                        Styles={{ width: 1024 }}
                        isLoading={isLoading}
                        btnViewHadle={this.btnViewHadle(PathName.SupplierManage)}
                        chartType={2} />
                </div>
            </div>)
    }

    btnViewHadle = (value) => () => { this.props.history.push(value); }
}

function mapStateToProps(state, ownProps) {
    return { ...state };
}

function mapDispatchToProps(dispatch) {
    return {
        getAPIBestAgentList: (_filter) => {
            dispatch(StatiticActions.getBestAgentList(_filter))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AgentStatPanel);
